<div class="content governance-page">
  <div class="container-fluid">
    <div class="governance-header">
      <div>
        <div class="governance-title-row">
          <h1 class="dashboard-title">Quality Governance Dashboard</h1>
          <span class="admin-view-pill"><i class="fa-solid fa-crown mr-1"></i>Admin View</span>
        </div>
        <p>Enterprise audit quality and compliance overview</p>
      </div>
    </div>

    <div class="governance-filter-card">
      <div class="governance-filter-field">
        <label>Date Range</label>
        <input [(ngModel)]="dateRange" type="text">
      </div>
      <div class="governance-filter-field">
        <label>Client</label>
        <select [(ngModel)]="selectedClient">
          <option>All Clients</option>
          <option>Guardian Dentistry</option>
          <option>DAG Dental</option>
          <option>HQRC</option>
        </select>
      </div>
      <div class="governance-filter-field">
        <label>Project</label>
        <select [(ngModel)]="selectedProject">
          <option>All Projects</option>
          <option>Guardian Dentistry</option>
          <option>DAG</option>
          <option>HQRC</option>
        </select>
      </div>
      <div class="governance-filter-field">
        <label>Auditor Group</label>
        <select [(ngModel)]="selectedAuditorGroup">
          <option>All Auditor Groups</option>
          <option>Internal</option>
          <option>External</option>
        </select>
      </div>
      <div class="governance-filter-field">
        <label>Form Type</label>
        <select [(ngModel)]="selectedFormType">
          <option>All Form Types</option>
          <option>FULL FORM</option>
          <option>SHORT FORM</option>
          <option>ELIG CHECK</option>
        </select>
      </div>
      <button type="button" class="btn btn-primary governance-apply-btn">
        <i class="fa-solid fa-filter mr-2"></i>Apply
      </button>
    </div>

    <div class="governance-kpi-grid">
      <div class="governance-kpi-card" *ngFor="let kpi of kpis">
        <div class="governance-kpi-icon" [ngClass]="'tone-' + kpi.tone">
          <i [class]="kpi.icon"></i>
        </div>
        <div class="governance-kpi-copy">
          <div class="governance-kpi-label">{{ kpi.label }}</div>
          <div class="governance-kpi-value">{{ kpi.value }}</div>
        </div>
        <div class="governance-kpi-trend" [class.trend-down]="kpi.direction === 'down'">
          <i [class]="kpi.direction === 'up' ? 'fa-solid fa-arrow-up' : 'fa-solid fa-arrow-down'"></i>
          {{ kpi.trend }}
        </div>
      </div>
    </div>

    <div class="governance-chart-grid">
      <div class="governance-panel">
        <div class="governance-panel-title">
          <span>Quality Score Trend by Week</span>
          <span class="panel-select">Weekly <i class="fa-solid fa-chevron-down ml-2"></i></span>
        </div>
        <div class="trend-chart">
          <div class="trend-y-labels"><span>100%</span><span>90%</span><span>80%</span><span>70%</span></div>
          <div class="trend-plot">
            <svg viewBox="0 0 700 150" preserveAspectRatio="none" aria-label="Quality score trend">
              <defs>
                <linearGradient id="qualityArea" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stop-color="#3b82f6" stop-opacity=".20"></stop>
                  <stop offset="100%" stop-color="#3b82f6" stop-opacity=".02"></stop>
                </linearGradient>
              </defs>
              <polyline fill="url(#qualityArea)" stroke="none" points="0,140 0,105 54,102 108,99 162,90 216,84 270,80 324,79 378,74 432,70 486,68 540,66 594,64 648,60 700,52 700,140"></polyline>
              <polyline fill="none" stroke="#1f7aff" stroke-width="3" points="0,105 54,102 108,99 162,90 216,84 270,80 324,79 378,74 432,70 486,68 540,66 594,64 648,60 700,52"></polyline>
            </svg>
            <div class="trend-x-labels"><span>Jan 1</span><span>Jan 15</span><span>Feb 1</span><span>Feb 15</span><span>Mar 1</span><span>Mar 15</span><span>Mar 31</span></div>
          </div>
        </div>
      </div>

      <div class="governance-panel">
        <div class="governance-panel-title">
          <span>Findings by Category</span>
          <span class="panel-select">All Projects <i class="fa-solid fa-chevron-down ml-2"></i></span>
        </div>
        <div class="category-bars">
          <div class="category-row" *ngFor="let item of findingsByCategory">
            <span class="category-name">{{ item.label }}</span>
            <div class="category-track"><span [style.width.%]="getCategoryWidth(item.value)"></span></div>
            <strong>{{ item.value }}</strong>
          </div>
        </div>
      </div>
    </div>

    <div class="governance-table-grid">
      <div class="governance-panel">
        <div class="governance-panel-title">Project / Client Quality Ranking</div>
        <div class="table-responsive">
          <table class="table table-sm governance-table">
            <thead><tr><th>#</th><th>Project</th><th>Client</th><th>Audits</th><th>Quality Score</th><th>Open</th><th>Critical</th></tr></thead>
            <tbody>
              <tr *ngFor="let row of projectRankings; let i = index">
                <td>{{ i + 1 }}</td>
                <td class="table-link">{{ row.project }}</td>
                <td>{{ row.client }}</td>
                <td>{{ row.audits }}</td>
                <td><span class="score-pill">{{ row.score }}</span></td>
                <td>{{ row.open }}</td>
                <td>{{ row.critical }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="governance-panel">
        <div class="governance-panel-title">Auditor Performance Summary</div>
        <div class="table-responsive">
          <table class="table table-sm governance-table">
            <thead><tr><th>#</th><th>Auditor</th><th>Group</th><th>Audits</th><th>Quality Score</th><th>Findings</th><th>Rework</th></tr></thead>
            <tbody>
              <tr *ngFor="let row of auditorPerformance; let i = index">
                <td>{{ i + 1 }}</td>
                <td class="table-link">{{ row.auditor }}</td>
                <td>{{ row.group }}</td>
                <td>{{ row.audits }}</td>
                <td><span class="score-pill">{{ row.score }}</span></td>
                <td>{{ row.findings }}</td>
                <td>{{ row.rework }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="governance-summary-grid">
      <div class="summary-card">
        <div class="summary-ring">94.2%</div>
        <div><strong>SLA Compliance</strong><span>403 on time · 18 grace · 7 overdue</span></div>
      </div>
      <div class="summary-card">
        <div class="summary-ring">96.7%</div>
        <div><strong>Repository Publish Rate</strong><span>414 published · 11 pending · 3 not published</span></div>
      </div>
      <div class="summary-card">
        <div class="summary-ring">5.1%</div>
        <div><strong>Rework Distribution</strong><span>406 no rework · 18 one rework · 4 multiple</span></div>
      </div>
    </div>
  </div>
</div>
